export const DMS_MODULE = 'OjeteVozyExternal';
